import { rotationForDefaultAssetType } from '@ikegps/core-api';
import type { LegendItem } from '../topological.editor.map/map.legend';
import { fetchAssetTypeIconSvg, rotateSvg } from './asset.type.icon.fetch';

/**
 * Fetches the recolored icon-only SVG (no pin) for each `assetType` legend item, so the print legend
 * can draw the real glyph instead of a plain colored dot — pdfMake can't render the Material Icons
 * font directly, so the glyph is rendered server-side (@see `extractIconOnlySvg`) and embedded as SVG.
 * Rotates it to match the preset's glyph rotation (e.g. Valve's hourglass, turned on its side), same as
 * every other rendering of the icon. Falls back to leaving `svg` unset (the plain dot) for any icon
 * that fails to fetch.
 */
export async function resolveAssetTypeIconSvgs(items: LegendItem[]): Promise<LegendItem[]> {
	return Promise.all(
		items.map(async (item) => {
			if (item.swatch.kind !== 'assetType') {
				return item;
			}
			const fetched = await fetchAssetTypeIconSvg(item.swatch.icon, item.swatch.color);
			if (fetched == null) {
				return item;
			}
			const svg = rotateSvg(fetched, rotationForDefaultAssetType(item.swatch.title));
			return { ...item, swatch: { ...item.swatch, svg } };
		})
	);
}
